import React from 'react'
import Progress from '~/components/atoms/progress/Progress'

export enum SignupProgressStatus {
  FORM = 'FORM',
  VERIFY = 'VERIFY',
}

const progressItemText = (status: SignupProgressStatus) => {
  switch (status) {
    case SignupProgressStatus.FORM:
      return 'signup:progress.form'
    case SignupProgressStatus.VERIFY:
      return 'signup:progress.verify'
  }
}

interface Props {
  status: SignupProgressStatus
}

const SignupProgress = ({status}: Props) => {
  return (
    <Progress statuses={SignupProgressStatus} current={status} translate={progressItemText}/>
  )
}

export default SignupProgress